import { Box, Button, Divider, Grid2, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { Add, Remove } from '@mui/icons-material';
import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '../helper';

export default function ChooseTicketCategory({ details, setNextButtonActive, values }) {
  const { t } = useTranslation('checkout');
  const theme = useTheme();
  useEffect(() => {
    if (Object.entries(values).find(([key, value]) => key.startsWith('product_') && value > 0)) {
      setNextButtonActive(true);
      return;
    }
    setNextButtonActive(false);
  }, [values]);

  return (
    <Box>
      <Typography variant="h5" gutterBottom sx={{ marginBottom: 4 }}>
        {t('steps.chooseTicket')}
      </Typography>
      {details.products?.map((product) => (
        <div key={product.id}>
          <Grid2 container sx={{ my: 2 }}>
            <Grid2 size={{ xs: 5, sm: 8 }} sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="h6">
                {product.name}
                <Typography variant="subtitle2" sx={{ flex: 1, color: '#9e9e9e' }}>
                  {product.shortDescription}
                </Typography>
              </Typography>
            </Grid2>
            <Grid2 size={2} sx={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}>
              {product.salesPrice && (
                <Typography
                  variant="body2"
                  sx={{
                    color: 'red',
                    textDecoration:
                    'line-through',
                    position: 'absolute',
                    marginTop: '-25px',
                  }}
                >
                  {formatNumber(product.price)}
                </Typography>
              )}
              <Typography variant="h6" sx={{ width: '100%', [theme.breakpoints.down('lg')]: { marginTop: '17px' } }}>
                {formatNumber(product.salesPrice || product.price)}
              </Typography>
            </Grid2>
            <Grid2 size={{ xs: 5, sm: 2 }}>
              <Field
                name={`product_${product.id}`}
              >
                {({ input }) => (
                  <Box sx={{ display: 'flex', alignItems: 'center', float: 'right', height: '100%' }}>
                    {product.isAvailable ? (
                      <>
                        <Button
                          variant="outlined"
                          size="small"
                          sx={{ width: '28px', minWidth: 0, marginRight: 1 }}
                          disabled={input.value === 0}
                          onClick={() => {
                            if (input.value === 0) return;
                            input.onChange(input.value - 1);
                          }}
                        >
                          <Remove />
                        </Button>
                        <Typography sx={{ fontSize: '20px' }}>{input.value}</Typography>
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ width: '28px', minWidth: 0, marginLeft: 1 }}
                          disabled={product.maxQuantity <= input.value}
                          onClick={() => {
                            input.onChange(input.value + 1);
                          }}
                        >
                          <Add />
                        </Button>
                      </>
                    ) : (
                      <Typography sx={{ color: '#d32f2f' }}>{t('soldOut')}</Typography>
                    )}
                  </Box>
                )}
              </Field>
            </Grid2>
          </Grid2>
          <Divider />
        </div>
      ))}
    </Box>
  );
}
